import React from "react";

const DownloadSection = () => {
  return (
    <div className="download-sec-1 overflow-hidden p-0">
      <div className="container p-0">
        <div className="row gy-4 align-items-center p-0">

          {/* Left Content */}
          <div className="col-lg-7 ">
            <div className="download-text-left">

              <div className="title-area mb-30">
                <h2 className="sec-title">
                  Your Trusted Travel Partner in Pune
                </h2>

                <p className="sec-text fs-18 pe-xl-5 me-xl-5">
                  Rising Cab Service provides reliable, comfortable, and affordable
                  transportation solutions for local travel, airport transfers,
                  corporate trips, family vacations, and outstation journeys.
                  Our professional drivers and well-maintained vehicles ensure
                  a smooth travel experience every time.
                </p>
              </div>

              <div className="checklist style2 mb-35">
                <ul>
                  <li>
                    <i className="fa-solid fa-check"></i>
                    Airport Pickup & Drop Services
                  </li>

                  <li>
                    <i className="fa-solid fa-check"></i>
                    Outstation & One Way Cab Booking
                  </li>

                  <li>
                    <i className="fa-solid fa-check"></i>
                    Corporate Travel Solutions
                  </li>

                  <li>
                    <i className="fa-solid fa-check"></i>
                    Clean Vehicles & Professional Drivers
                  </li>

                  <li>
                    <i className="fa-solid fa-check"></i>
                    24×7 Customer Support
                  </li>
                </ul>
              </div>
 {/* Buttons */}
  <div className="d-flex gap-3">
    <a href="tel:+919272511548" className="th-btn">
      Call Now
    </a>

    <a
      href="https://wa.me/919272511548"
      target="_blank"
      rel="noreferrer"
      className="th-btn style3"
    >
      WhatsApp Us
    </a>
  </div>
          

            </div>
          </div>

          {/* Right Image */}
     <div className="col-lg-5">
  <div className="download-thumb text-center mb-4">
    <img
      src="/images/Rising-cab.png"
      alt="Rising Cab Service"
      className="img-fluid"
      style={{
        borderRadius: "20px",
        boxShadow: "0 15px 40px rgba(0,0,0,0.12)",
      }}
    />
  </div>

  {/* Stats */}
  <div className="row g-3 mb-4">
    <div className="col-4">
      <div
        style={{
          background: "#F26722",
          color: "#fff",
          padding: "20px",
          textAlign: "center",
          borderRadius: "10px",
        }}
      >
        <h4>5000+</h4>
        <small>Happy Trips</small>
      </div>
    </div>

    <div className="col-4">
      <div
        style={{
          background: "#0A2A66",
          color: "#fff",
          padding: "20px",
          textAlign: "center",
          borderRadius: "10px",
        }}
      >
        <h4>24×7</h4>
        <small>Support</small>
      </div>
    </div>

    <div className="col-4">
      <div
        style={{
          background: "#198754",
          color: "#fff",
          padding: "20px",
          textAlign: "center",
          borderRadius: "10px",
        }}
      >
        <h4>100%</h4>
        <small>Safe Ride</small>
      </div>
    </div>
  </div>

  {/* Services */}
  <div
    style={{
      background: "#fff",
      padding: "20px",
      borderRadius: "15px",
      boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
      marginBottom: "20px",
    }}
  >
    <h5
      style={{
        color: "#0A2A66",
        fontWeight: "700",
        marginBottom: "15px",
      }}
    >
      Our Services
    </h5>

    <div className="row">
      <div className="col-6 mb-2">✈ Airport Transfer</div>
      <div className="col-6 mb-2">🚖 Local Cabs</div>
      <div className="col-6 mb-2">🏢 Corporate Travel</div>
      <div className="col-6 mb-2">🌄 Outstation Trips</div>
    </div>
  </div>

 
</div>




        </div>
      </div>
    </div>
  );
};

export default DownloadSection;